import { Injectable, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  Routes,
  RouterModule,
  RouterStateSnapshot,
  CanDeactivate,
  ActivatedRouteSnapshot,
} from "@angular/router";

import { SharedModule } from "../shared/shared.module";
import { IconsModule } from "@va/core-library/icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ComparativeAnalysisComponent } from "./comparative-analysis/comparative-analysis.component";
import { ComparativeTrendComponent } from "./comparative-trend/comparative-trend.component";

import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzSelectModule } from "ng-zorro-antd/select";
import { ComparativeTickerModalComponent } from "./comparative-ticker-modal/comparative-ticker-modal.component";
import { ComparativeTickerSearchComponent } from "./comparative-ticker-search/comparative-ticker-search.component";
import { ComparativeTickerSearchMenuComponent } from "./comparative-ticker-search-menu/comparative-ticker-search-menu.component";
import { ComparativeReviSurComponent } from "./comparative-revisur/comparative-revi-sur.component";
import { ComparativeComparisionComponent } from "./comparative-comparision/comparative-comparision.component";
import { ComparativeValuationComponent } from "./comparative-valuation/comparative-valuation.component";
import { ComparativeChartsComponent } from "./comparative-charts/comparative-charts.component";
import { ComparativeSurpriseComponent } from "./comparative-surprise/comparative-surprise.component";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { GlobalSubheaderModule } from "../global-subheader/global-subheader.module";
import { TrendGridComponent } from "./trend-grid/trend-grid.component";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { ComparisionGridComponent } from "./comparision-grid/comparision-grid.component";
import { ChartContentComponent } from "./chart-content/chart-content.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { NzTransferModule } from "ng-zorro-antd/transfer";
import { ComparativeChartTickerFilterComponent } from "./comparative-chart-ticker-filter/comparative-chart-ticker-filter.component";
import { NzStepsModule } from "ng-zorro-antd/steps";
import { CreateNewComparativeAnalysisWizardComponent } from "./create-new-comparative-analysis-wizard/create-new-comparative-analysis-wizard.component";
import { CommonActionModalComponent } from "./common-action-modal/common-action-modal.component";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { ComparativeGridComponent } from "./comparative-grid/comparative-grid.component";
import { MatTableModule } from "@angular/material/table";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { ComparativeValuationGridComponent } from "./comparative-valuation-grid/comparative-valuation-grid.component";
import { ComparativeTprComponent } from "./comparative-tpr/comparative-tpr.component";
import { TprModule } from "src/app/tpr/tpr.module";
import { ButtonModule } from "@va/core-library/button";

@Injectable({
  providedIn: "root",
})
export class CanDeactivateGuard
  implements CanDeactivate<ComparativeAnalysisComponent>
{
  canDeactivate(
    component: ComparativeAnalysisComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): boolean {
    if (component.hasUnsavedData) {
      if (!component.promptModal) {
        component.promptToSave(nextState);
      }
      return false;
    }
    return true;
  }
}

const comparativeAnalysisRoutes: Routes = [
  {
    path: ":pageType",
    component: ComparativeAnalysisComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      title: "Comparative Analysis",
    },
  },
  {
    path: ":pageType/:compId",
    component: ComparativeAnalysisComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      title: "Comparative Analysis",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(comparativeAnalysisRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class ComparativeAnalysisRoutingModule {}

@NgModule({
  declarations: [
    ComparativeAnalysisComponent,
    ComparativeTrendComponent,
    ComparativeReviSurComponent,
    ComparativeComparisionComponent,
    ComparativeValuationComponent,
    ComparativeComparisionComponent,
    ComparativeChartsComponent,
    ComparativeSurpriseComponent,
    TrendGridComponent,
    ComparativeChartTickerFilterComponent,
    ComparativeTickerModalComponent,
    ComparativeTickerSearchComponent,
    ComparativeTickerSearchMenuComponent,
    ComparisionGridComponent,
    ChartContentComponent,
    CreateNewComparativeAnalysisWizardComponent,
    CommonActionModalComponent,
    ComparativeGridComponent,
    ComparativeValuationGridComponent,
    ComparativeTprComponent,
  ],
  imports: [
    ComparativeAnalysisRoutingModule,
    CommonModule,
    SharedModule,
    IconsModule,
    NzTabsModule,
    NzSkeletonModule,
    NzCheckboxModule,
    NzRadioModule,
    NzTreeModule,
    NzPopoverModule,
    NzSpinModule,
    NzGridModule,
    NzModalModule,
    NzToolTipModule,
    NzDropDownModule,
    NzSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PeriodFilterModule,
    CurrencySelectModule,
    GlobalSubheaderModule,
    NzSwitchModule,
    ChartPlotterModule,
    NzStepsModule,
    NzTransferModule,
    NzCollapseModule,
    MatTableModule,
    MatMenuModule,
    MatPaginatorModule,
    TprModule,
    ButtonModule,
  ],
  exports: [],
})
export class ComparativeAnalysisModule {}
